module.exports = __webpack_public_path__ + "media/components/country-flag/static/ps-a1d366d0063072c2fe708fe9144844c5.svg";